<template>
	<v-dialog v-model="dialog" persistent max-width="650px" scrollable>
		<v-card>
			<v-card-title class="justify-space-between pb-0">
				<div class="font-size-14 cl-secondary">Detail Data Mitra</div>
				<v-btn small text class="px-0 mr-n4" @click="modalHide">
					<v-icon color="red">mdi-close</v-icon>
				</v-btn>
			</v-card-title>
			<template v-if="params">
				<v-card-text>
					<v-row>
						<v-col cols="12" sm="12" md="12" class="pt-5">
							<v-card class="pa-4 elevation-0 rounded-lg mb-2" outlined>
								<div class="font-size-12 cl-primary">Data Personal</div>
								<div class="pt-5">
									<v-row>
										<v-col cols="12" sm="12" md="4">
											<div class="text-center">
												<v-img height="100" width="100" class="user-img mx-auto rounded-pill" :src="(params.member_image_url) ? params.member_image_url : 'assets/image/profile-pict.png'"></v-img>
												<div class="bottom-shadow"></div>
											</div>
										</v-col>
										<v-col cols="12" sm="12" md="8" class="px-4">
											<div class="d-block font-size-10 mb-3 px-2">
												<div class="d-flex flex-column">
													<span class="d-flex align-center grey--text"><v-icon small class="mr-2" color="grey">mdi-account</v-icon>Nama Lengkap</span>
													<span class="font-weight-600 cl-secondary text-capitalize pl-6">{{ params.member_name | emptyData }}</span>
												</div>
											</div>

											<div class="d-block font-size-10 mb-3 px-2">
												<div class="d-flex flex-column">
													<span class="d-flex align-center grey--text"><v-icon small class="mr-2" color="grey">mdi-email</v-icon>Email</span>
													<span class="font-weight-600 cl-secondary text-capitalize pl-6">{{ params.member_email | emptyData }}</span>
												</div>
											</div>

											<div class="d-block font-size-10 mb-3 px-2">
												<div class="d-flex flex-column">
													<span class="d-flex align-center grey--text"><v-icon small class="mr-2" color="grey">mdi-card-account-details</v-icon>No. Ktp</span>
													<span class="font-weight-600 cl-secondary text-capitalize pl-6">{{ params.member_identity_no | emptyData }}</span>
												</div>
											</div>

											<div class="d-block font-size-10 mb-3 px-2">
												<div class="d-flex flex-column">
													<span class="d-flex align-center grey--text"><v-icon small class="mr-2" color="grey">mdi-cellphone</v-icon>No. Handphone</span>
													<span class="font-weight-600 cl-secondary text-capitalize pl-6">{{ params.member_mobilephone | emptyData }}</span>
												</div>
											</div>

											<div class="d-block font-size-10 mb-3 px-2">
												<div class="d-flex flex-column">
													<span class="d-flex align-center grey--text"><v-icon small class="mr-2" color="grey">mdi-map-marker-radius-outline</v-icon>Alamat</span>
													<span class="font-weight-600 cl-secondary text-capitalize pl-6">{{ params.member_address | emptyData }}</span>
												</div>
											</div>

											<div class="d-block font-size-10 mb-3 px-2">
												<div class="d-flex flex-column">
													<span class="d-flex align-center grey--text"><v-icon small class="mr-2" color="grey">mdi-map-marker-right-outline</v-icon>Kota</span>
													<span class="font-weight-600 cl-secondary text-capitalize pl-6">{{ getCityName(params.member_city_id) }}</span>
												</div>
											</div>

											<div class="d-block font-size-10 mb-3 px-2">
												<div class="d-flex flex-column">
													<span class="d-flex align-center grey--text"><v-icon small class="mr-2" color="grey">mdi-map-marker-right-outline</v-icon>Provinsi</span>
													<span class="font-weight-600 cl-secondary text-capitalize pl-6">{{ getProvinceName(params.member_province_id) }}</span>
												</div>
											</div>
										</v-col>
									</v-row>
								</div>
							</v-card>

							<v-card class="pa-4 elevation-0 rounded-lg mb-2" outlined>
								<div class="font-size-12 cl-primary">Data Ahli Waris</div>
								<div class="pt-5">
									<v-row>
										<v-col cols="12" sm="12" md="4" class="px-0">
											<div class="d-block font-size-10 mb-3 px-2">
												<div class="d-flex flex-column">
													<span class="d-flex align-center grey--text"><v-icon small class="mr-2" color="grey">mdi-account</v-icon>Nama Ibu Kandung</span>
													<span class="font-weight-600 cl-secondary text-capitalize pl-6">{{ params.member_mother_name | emptyData }}</span>
												</div>
											</div>
										</v-col>

										<v-col cols="12" sm="12" md="4" class="px-0">
											<div class="d-block font-size-10 mb-3 px-2">
												<div class="d-flex flex-column">
													<span class="d-flex align-center grey--text"><v-icon small class="mr-2" color="grey">mdi-account</v-icon>Nama Ahli Waris</span>
													<span class="font-weight-600 cl-secondary text-capitalize pl-6">{{ params.member_devisor_name | emptyData }}</span>
												</div>
											</div>
										</v-col>

										<v-col cols="12" sm="12" md="4" class="px-0">
											<div class="d-block font-size-10 mb-3 px-2">
												<div class="d-flex flex-column">
													<span class="d-flex align-center grey--text"><v-icon small class="mr-2" color="grey">mdi-account</v-icon>Hubungan Ahli Waris</span>
													<span class="font-weight-600 cl-secondary text-capitalize pl-6">{{ params.member_devisor_relation | emptyData }}</span>
												</div>
											</div>
										</v-col>
									</v-row>
								</div>
							</v-card>

							<v-card class="pa-4 elevation-0 rounded-lg mb-2" outlined>
								<div class="font-size-12 cl-primary">Data Bank</div>
								<div class="pt-5">
									<v-row>
										<v-col cols="12" sm="12" md="4" class="px-0">
											<div class="d-block font-size-10 mb-3 px-2">
												<div class="d-flex flex-column">
													<span class="d-flex align-center grey--text"><v-icon small class="mr-2" color="grey">mdi-account</v-icon>Nama Rekening</span>
													<span class="font-weight-600 cl-secondary text-capitalize pl-6">{{ params.member_bank_account_name | emptyData }}</span>
												</div>
											</div>
										</v-col>

										<v-col cols="12" sm="12" md="4" class="px-0">
											<div class="d-block font-size-10 mb-3 px-2">
												<div class="d-flex flex-column">
													<span class="d-flex align-center grey--text"><v-icon small class="mr-2" color="grey">mdi-account-box-outline</v-icon>Nomor Rekening</span>
													<span class="font-weight-600 cl-secondary text-capitalize pl-6">{{ params.member_bank_account_no | emptyData }}</span>
												</div>
											</div>
										</v-col>

										<v-col cols="12" sm="12" md="4" class="px-0">
											<div class="d-block font-size-10 mb-3 px-2">
												<div class="d-flex flex-column">
													<span class="d-flex align-center grey--text"><v-icon small class="mr-2" color="grey">mdi-bank-outline</v-icon>Nama Bank</span>
													<span class="font-weight-600 cl-secondary text-capitalize pl-6">{{ params.member_bank_name | emptyData }}</span>
												</div>
											</div>
										</v-col>

										<v-col cols="12" sm="12" md="4" class="px-0">
											<div class="d-block font-size-10 mb-3 px-2">
												<div class="d-flex flex-column">
													<span class="d-flex align-center grey--text"><v-icon small class="mr-2" color="grey">mdi-map-marker-right-outline</v-icon>Kota Bank</span>
													<span class="font-weight-600 cl-secondary text-capitalize pl-6">{{ getCityName(params.member_bank_city_id) }}</span>
												</div>
											</div>
										</v-col>

										<v-col cols="12" sm="12" md="4" class="px-0">
											<div class="d-block font-size-10 mb-3 px-2">
												<div class="d-flex flex-column">
													<span class="d-flex align-center grey--text"><v-icon small class="mr-2" color="grey">mdi-map-marker-right-outline</v-icon>Nama Cabang</span>
													<span class="font-weight-600 cl-secondary text-capitalize pl-6">{{ params.member_bank_branch_name | emptyData }}</span>
												</div>
											</div>
										</v-col>
									</v-row>
								</div>
							</v-card>
						</v-col>
					</v-row>
				</v-card-text>
				<v-card-actions class="justify-center">
					<v-col cols="3">
						<v-btn depressed block color="primary" class="white--text rounded-lg text-capitalize" @click="modalHide">
							<v-icon small v-if="false">mdi-close</v-icon>
							<span>Tutup</span>
						</v-btn>
					</v-col>
				</v-card-actions>
			</template>
		</v-card>
	</v-dialog>
</template>

<script>
import { mapActions, mapState } from 'vuex'
export default {
	data () {
		return {
			dialog: false,
			joinDate: false,
			loaderData: false
		}
	},
	computed:{
		...mapState('option', ['optProvince', 'optCity']),
	},
	props: ['params'],
	created() {
		this.getOptionProvince()
		this.getOptionCity()
	},
	methods :{
		...mapActions('option', ['getOptionProvince', 'getOptionCity']),

		modalShow() {
			this.dialog = true
		},
		modalHide() {
			this.dialog = false
			this.loaderData = false
		},
		getCityName(id) {
			if(id && Object.keys(this.optCity).length > 0) {
				if(this.optCity[id] !== undefined) {
					return this.optCity[id]
				} else {
					return '-'
				}
			} else {
				return '-'
			}
		},

		getProvinceName(id) {
			if(id && Object.keys(this.optProvince).length > 0) {
				if(this.optProvince[id] !== undefined) {
					return this.optProvince[id]
				} else {
					return '-'
				}
			} else {
				return '-'
			}
		},
	}
};
</script>